export default "__VITE_ASSET__Bh47fl20__"